import Close from '@mui/icons-material/Close'
import Delete from '@mui/icons-material/Delete'
import {Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../localization'

import {useDeleteComment} from './hooks/useDeleteComment'

export const DeleteComment: React.FC<{
  nodeId: number
  commentId: string
  analysisId: string
  closeModal: Function
  opened: boolean
}> = ({nodeId, analysisId, closeModal, opened, commentId}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  // node deletion

  const {data, mutate, isPending: isLoading} = useDeleteComment(analysisId, nodeId)

  useEffect(() => {
    if (data !== undefined && !isLoading) {
      closeModal()
    }
  }, [data, isLoading])

  return (
    <Dialog open={opened} onClose={() => closeModal} maxWidth="md" data-test-id="remove-task-modal">
      <DialogTitle>
        <Grid container justifyContent="flex-start" alignItems="center">
          {t('headings.removeComment')}
        </Grid>
      </DialogTitle>
      <DialogContent sx={{paddingBottom: 0}}>
        <Grid container justifyContent="flex-start">
          {`${t('headings.removeCommentText')} ?`}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="flex-end" my={1}>
          <Button
            startIcon={<Close />}
            variant="outlined"
            color="secondary"
            onClick={() => closeModal()}
            data-test-id="node-form-cancel-button"
          >
            {t('buttons.cancel')}
          </Button>
          <Button
            startIcon={<Delete />}
            variant="contained"
            color="error"
            onClick={() => mutate(commentId)}
            sx={{marginLeft: 1}}
            data-test-id="node-form-cancel-button"
          >
            {t('buttons.deleteConfirm')}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}
